import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

import notSupportImg from './images/notSupport.png';
import logoImg from './images/darkLogo.png';

function NotSupport(props) {
  const { type, classes } = props;
  let description = 'Please update your browser to the latest version to use Alfred WebViewer.';
  if (type === 'browser') {
    description =
      'This web browser is not supported. Please use the <b>Google Chrome</b>, <b>Safari</b> or <b>Firefrox</b> browser to continue to use Alfred WebViewer.';
  }
  return (
    <div className={classes.container}>
      <img className={classes.img} width="195" height="195" src={notSupportImg} />
      <p className={classes.title}>
        <FormattedMessage id={props.title} />
      </p>
      <p className={classes.description} dangerouslySetInnerHTML={{ __html: props.description }}></p>
    </div>
  );
}

const styles = (theme) => ({
  container: {
    width: '100%',
    height: `100%`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  title: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 26,
    lineHeight: '36px',

    textAlign: 'center',

    color: '#1A1A1A',
    margin: '24px 0 15px 0',
    maxWidth: 300,
  },
  description: {
    maxWidth: 300,
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '17px',
    lineHeight: '24px',
    /* or 141% */

    textAlign: 'center',

    color: '#979797',
  },
  logoImg: {
    height: 35,
    width: 150,
    objectFit: 'contain',
    marginLeft: 'calc(5% - 24px)',
  },
  webLogoImg: {
    height: 35,
    width: 157,
    objectFit: 'contain',
  },
});

export default withStyles(styles)(NotSupport);
